/* eslint-disable global-require */
module.exports = {
  arithmetic: require('./arithmetic'),
  commands: require('./commands'),
  datetime: require('./datetime'),
  device: require('./device'),
  event: require('./event'),
  house: require('./house'),
  object: require('./object-manipulation'),
  print: require('./print'),
  role: require('./role'),
  strings: require('./strings'),
};
